import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableModule } from './data-table/data-table.module';
import { TablePipe } from './common/utils/table.pipe';
import { FilterPipe } from './common/utils/filter.pipe';

@NgModule({
  declarations: [TablePipe, FilterPipe],
  imports: [
    CommonModule,
    DataTableModule
  ],
  exports: [DataTableModule, TablePipe, FilterPipe]
})
export class TableModule { }
